import { render, staticRenderFns } from "./SeriesBookTile.vue?vue&type=template&id=51a86e6e&scoped=true&"
import script from "./SeriesBookTile.vue?vue&type=script&lang=js&"
export * from "./SeriesBookTile.vue?vue&type=script&lang=js&"
import style0 from "./SeriesBookTile.vue?vue&type=style&index=0&id=51a86e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a86e6e",
  null
  
)

component.options.__file = "SeriesBookTile.vue"
export default component.exports